<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="auto">
        <v-img
          :src="require('@/assets/icons/tabler_template.svg')"
          contain
          max-width="36"
          height="36"
          class="mr-n2"
        />
      </v-col>
      <v-col
        class="text-start ml-n2 accentElement--text"
        style="font-size: 22px"
      >
        {{ $t("story.template") }}</v-col
      >
    </v-row>
    <v-row>
      <v-col style="position: relative" class="mr-2">
        <v-text-field
          disabled="disabled"
          solo
          style="position: absolute; left: 0px"
          outlined
        >
        </v-text-field>
        <v-checkbox
          :disabled="disabled"
          v-model="localStory.isTemplate"
          :label="$t('story.enableAsTemplate')"
          @change="emitUpdate"
        ></v-checkbox>
      </v-col>
      <!-- Template Icon Selector -->
      <v-col>
        <v-select
          :disabled="disabled"
          v-model="localStory.templateIcon"
          :items="icons"
          label="Template Icon"
          item-text="name"
          item-value="icon"
          solo
          outlined
          @change="emitUpdate"
        >
          <template v-slot:selection="data">
            <v-icon class="mr-2" :color="data.item.color">{{
              data.item.icon
            }}</v-icon>
            {{ data.item.name }}
          </template>
          <template v-slot:item="data">
            <v-icon class="mr-8" :color="data.item.color">{{
              data.item.icon
            }}</v-icon>
            {{ data.item.name }}
          </template>
        </v-select>
      </v-col>
      <v-col>
        <!-- Template Preview Link -->
        <v-text-field
          :disabled="disabled"
          v-model="localStory.templatePreviewLink"
          :label="$t('story.addATemplatePreviewLink')"
          placeholder="Enter template preview link"
          outlined
          solo
          @change="emitUpdate"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!-- Template Description -->
        <v-textarea
          :disabled="disabled"
          v-model="localStory.templateDescription"
          :label="$t('story.addATemplateDescription')"
          placeholder="Enter description for the template"
          rows="4"
          outlined
          solo
          auto-grow
          @change="emitUpdate"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    story: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localStory: this.story,
      icons: [
        {
          icon: "mdi-puzzle",
          name: "Puzzle",
          color: "primary",
        },
        {
          icon: "mdi-ray-start-arrow",
          name: "Linear",
          color: "primary",
        },
        {
          icon: "mdi-source-branch",
          name: "Branch",
          color: "primary",
        },
        {
          icon: "mdi-treasure-chest",
          name: "Treasure Chest",
          color: "primary",
        },
        {
          icon: "mdi-magnify",
          name: "Magnify",
          color: "primary",
        },
        {
          icon: "mdi-shoe-sneaker",
          name: "Shoe Sneaker",
          color: "primary",
        },
        {
          icon: "mdi-run-fast",
          name: "Run Fast",
          color: "primary",
        },
        {
          icon: "mdi-bee-flower",
          name: "Bee Flower",
          color: "primary",
        },
        {
          icon: "mdi-leaf",
          name: "Leaf",
          color: "primary",
        },
      ],
    };
  },
  watch: {
    story: {
      handler(newValue) {
        this.localStory = newValue;
      },
      deep: true,
    },
  },
  methods: {
    emitUpdate() {
      this.$emit("updateStory", this.localStory);
    },
  },
};
</script>
